import { jsxs, jsx } from 'react/jsx-runtime';
import { IconExclamationCircleSolid } from '@circlefin/euclid-icons/common';
import classNames from 'classnames';

const InputGroup = (props)=>{
    const { children, name, className, direction = 'horizontal', disabled, label, labelledBy, errorMessage, ...rest } = props;
    // Make sure either the label or labelledBy prop exists or throw
    if (!label && !labelledBy) {
        throw new Error('Either label or labelledBy must be provided');
    }
    return jsxs("fieldset", {
        className: classNames('cb-input-group', className),
        ...labelledBy && {
            'aria-labelledby': labelledBy
        },
        ...rest,
        children: [
            label && jsx("legend", {
                className: classNames('label', {
                    disabled,
                    error: Boolean(errorMessage)
                }),
                "data-testid": "group-label",
                children: label
            }),
            jsx("div", {
                className: classNames(`input-layout`, {
                    row: direction === 'horizontal',
                    col: direction === 'vertical'
                }),
                "data-testid": "input-group",
                children: children
            }),
            errorMessage && jsxs("div", {
                className: "group-error",
                children: [
                    jsx(IconExclamationCircleSolid, {
                        className: "icon",
                        size: 20
                    }),
                    jsx("div", {
                        className: "message",
                        children: errorMessage
                    })
                ]
            })
        ]
    });
};
InputGroup.displayName = 'InputGroup';

export { InputGroup, InputGroup as default };
//# sourceMappingURL=InputGroup.es.js.map
